export const STRIPE_STYLING = {
  iconStyle: 'solid',
  style: {
    base: {
      iconColor: '#c7d2e3',
      color: '#000',
      width: '100%',
      fontWeight: 500,
      border: '20px solid black',
      fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {color: '#bebebe'},
      '::placeholder': {color: '#bebebe'},
    },
    invalid: {
      iconColor: '#8c011e',
      color: '#8c011e',
    },
  },
}
